<template>
  <div>
    <div
      class="parentNode"
      style="width: 70%; margin-left: auto; margin-right: auto"
    >
      <div class="childNode" v-for="(item, index) in items" :key="index">
        <div
          class="nodeitem item"
          :class="currlayer == item.id ? 'active' : ''"
          @click="loadinglayer(item)"
        >
          <span style="cursor:default">{{ $Lang.L({cn:item.displayNameCN,en:item.displayNameEN,hk:''}) }}</span>
        </div>
      </div>
    </div>
    <div class="parentNode">
      <div class="childNode" v-for="(item, index) in layerItem" :key="index">
        <div
          class="nodeitem item"
          :class="currproduct == item.id ? 'active' : ''"
          @click="loadingItem(item)"
        >
         <span style="cursor:default"> {{ $Lang.L({cn:item.displayName,en:item.displayNameEn,hk:''}) }}</span>
        </div>
      </div>
    </div>
    <div style="margin-top: 20px">
      <carouseml :items="productItem"></carouseml>
    </div>

    <!-- <infeeditem :key="index" v-for="(item, index) in layers">{{
      item.displayName
    }}</infeeditem> -->
  </div>
</template>
<script>
import "../assets/css/glass.css";
import common from "../webapi/common.js";
import carouseml from "../components/carouselMulti.vue";
// import infeeditem from "../components/infeedItem.vue";
export default {
  // name: "infeedmenu",
  props: ["items", "nodes"],
  components: { carouseml },
  data() {
    return {
      layerItem: [],
      productItem: [],
      currlayer: 0,
      currproduct: 0,
    };
  },
  watch:{
      'items'(){
          if(this.items.length>0){      
            this.loadinglayer(this.items[0])
            this.loadingItem(this.layerItem[0])
          }
      }
  },
  mounted() {
  },
  methods: {
    loadinglayer(target) {
      // debugger
      this.layerItem = this.nodes.filter((ele) => {
        return ele.parentId == target.id;
      });
      this.currlayer = target.id;
    },
    loadingItem(target) {
      this.currproduct = target.id;
      var hostu=window.location.origin
       
      this.$ajax
        .get(common.webapi.getWebProductBySort + target.id)
        .then((res) => {
          // debugger
          var arr = [];
          res.data.data.forEach((ele) => {
            arr.push({
              id: ele.id,
              displayName: ele.displayName,
              displayNameEn: ele.displayNameEn,
              remark:ele.remark,
              hrefUrl:hostu+'/#/web/products?id='+ele.id,
              targetUrl: ele.targetUrl,
            });
          });
          // console.log(arr)
          this.productItem = arr;
          // this.productItem = res.data.result.items;
        });
      // this.productItem=
    },
  },
};
</script>
<style scoped>
.parentNode {
  display: flex;
  margin-top: 20px;
}
.childNode {
  display: inline-flex;
  flex: 1;
}
.nodeitem {
  width: 100%;
  text-align: center;
  padding: 10px;
  /* margin:5px 10px; */
}
.item {
  border-right: 1px solid #eee;
  color: #eee;
  padding-bottom: 10px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.6s ease;
  -o-transition: all 0.6s ease;
  -moz-transition: all 0.6s ease;
  -webkit-transition: all 0.6s ease;
}
.active {
  background-color: #1a2f57;
}
.item:last-child() {
  border-right: none;
}
.item:hover {
  background: #e6400c;
  transition: all 0.9s ease;
  -o-transition: all 0.9s ease;
  -moz-transition: all 0.9s ease;
  -webkit-transition: all 0.9s ease;
}

.items {
  -moz-box-shadow: 6px 5px 13px #333333;
  -webkit-box-shadow: 6px 5px 13px #333333;
  box-shadow: 6px 5px 13px #333333;

  background: #eee;
  cursor: pointer;
  padding: 10px 20px 10px 20px;
  color: #1a2f57;
  -webkit-transition: color 400ms, background-color 400ms;
  -moz-transition: color 400ms, background-color 400ms;
  -o-transition: color 400ms, background-color 400ms;
  transition: color 400ms, background-color 400ms;
}

.items:hover {
  background-color: #32528e;
  color: white;
  color: #fff;
  box-shadow: 0 -3px 0 0 #000000 inset;
  -webkit-box-shadow: 0 -3px 0 0 #000000 inset;
}
</style>